"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonTab = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../../utils/classify"));
var _Button = require("../../Button");
var _ButtonTabModule = _interopRequireDefault(require("./ButtonTab.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ButtonTab = exports.ButtonTab = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    children,
    iconName,
    iconType = 'regular',
    size,
    onButtonTabSelect,
    id,
    selectedButtonTabId,
    disabled,
    isLeftCurved,
    isRightCurved,
    testId,
    ...props
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
    ...props,
    disabled: disabled,
    size: size,
    type: "tertiary",
    ref: ref,
    classNames: {
      wrapper: (0, _classify.default)(_ButtonTabModule.default.buttonTabWrapper, {
        [_ButtonTabModule.default.mediumButtonTab]: size === 'medium',
        [_ButtonTabModule.default.smallButtonTab]: size === 'small',
        [_ButtonTabModule.default.onlyIcon]: iconName && !children,
        [_ButtonTabModule.default.isSelected]: id === selectedButtonTabId,
        [_ButtonTabModule.default.disabled]: disabled,
        [_ButtonTabModule.default.leftCurved]: isLeftCurved,
        [_ButtonTabModule.default.rightCurved]: isRightCurved
      }, classNames?.wrapper),
      icon: _ButtonTabModule.default.icon
    },
    iconLeftName: iconName,
    iconLeftType: iconType,
    onClick: e => onButtonTabSelect && onButtonTabSelect(id, e),
    testId: testId,
    children: children
  });
});